import { loadLazyComponent } from '@wix/communities-forum-client-commons';

export const DevPanel = loadLazyComponent(() => import('./dev-panel'));
